




















import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class CardDashboard extends VueExtendedBaseComponent {

  @Prop({default: '-'}) private title!: string
  @Prop({default: '-'}) private value!: string
  @Prop() private icon!: string
  @Prop() private href!: string
  @Prop() private onClick!: () => {}

  private handleClickCard() {
    if (this.href) {
      this.$router.push(`/main/${this.href}`)
    }
    if (this.onClick) {
      this.onClick()
    }
  }
}
